import jobs from './apis/jobs';

export default () => ({
  jobs,
});
